import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227ed960"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background custom-dark overflow-hidden" }, null, -1))
const _hoisted_2 = { class: "w-screen h-screen flex flex-col px-12" }
const _hoisted_3 = { class: "text-6xl font-bold text-text-white text-center mt-32 mb-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "custom-container rounded-2xl z-10 flex flex-wrap p-4 text-center bg-background-medium items-center justify-center" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg width=\"240\" height=\"148\" viewBox=\"0 0 120 74\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"mt-10\" data-v-227ed960><path d=\"M55.7893 38.0144C51.3109 36.9677 47.383 34.2903 44.7716 30.5045C42.1601 26.7187 41.0525 22.0959 41.6646 17.5377C42.2767 12.9796 44.5647 8.81279 48.0824 5.85007C51.6001 2.88735 56.0952 1.34111 60.6911 1.51291C65.287 1.68472 69.6541 3.56224 72.9408 6.77932C76.2274 9.9964 78.198 14.3224 78.4681 18.9135C78.7382 23.5047 77.2885 28.0319 74.4017 31.6121C71.5149 35.1924 67.398 37.569 62.854 38.2785\" stroke=\"#212121\" stroke-width=\"3\" data-v-227ed960></path><circle cx=\"12\" cy=\"20\" r=\"10.5\" stroke=\"#212121\" stroke-width=\"3\" data-v-227ed960></circle><circle cx=\"108\" cy=\"20\" r=\"10.5\" stroke=\"#212121\" stroke-width=\"3\" data-v-227ed960></circle><path d=\"M54.5 21.5L57.5 24.5L64.5 15.5\" stroke=\"#212121\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-227ed960></path><path d=\"M76.3329 70.5L79.2379 56.557C79.9289 53.242 77.7409 50.013 74.4069 49.425L63.4999 47.5V34C63.4999 32.067 61.9329 30.5 59.9999 30.5C58.0669 30.5 56.4999 32.067 56.4999 34V57.358C56.4999 59.182 54.2579 60.054 53.0259 58.709L47.7069 52.906C46.4219 51.506 44.3299 51.202 42.6999 52.18C41.4649 52.921 41.0219 54.497 41.6899 55.773L49.4069 70.506\" stroke=\"#212121\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-227ed960></path></svg>", 1)
const _hoisted_7 = {
  key: 0,
  class: "text-3xl p-2 w-full text-5xl font-bold mt-10"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "text-3xl py-2 px-5 w-full text-4xl mt-10 min-h-description"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("mask", {
  id: "path-1-inside-1_463_2734",
  fill: "white"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M35.9988 0H11.9988V67H4.4141C1.09475 67 -0.780306 70.8097 1.24448 73.44L20.8302 98.8825C22.4314 100.963 25.5682 100.963 27.1694 98.8825L46.7551 73.44C48.7799 70.8097 46.9049 67 43.5855 67H35.9988V0Z"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.9988 0V-4H7.99876V0H11.9988ZM35.9988 0H39.9988V-4H35.9988V0ZM11.9988 67V71H15.9988V67H11.9988ZM1.24448 73.44L-1.92514 75.8799L-1.92514 75.88L1.24448 73.44ZM20.8302 98.8825L23.9998 96.4426V96.4426L20.8302 98.8825ZM27.1694 98.8825L23.9998 96.4426L27.1694 98.8825ZM46.7551 73.44L49.9247 75.88L49.9247 75.88L46.7551 73.44ZM35.9988 67H31.9988V71H35.9988V67ZM11.9988 4H35.9988V-4H11.9988V4ZM15.9988 67V0H7.99876V67H15.9988ZM4.4141 71H11.9988V63H4.4141V71ZM4.41411 71C4.40448 70.9875 4.40003 70.9799 4.39872 70.9776C4.3974 70.9752 4.39809 70.9761 4.39959 70.98C4.40107 70.9839 4.40269 70.989 4.40402 70.995C4.40534 71.0009 4.4061 71.0063 4.40647 71.011C4.40721 71.0203 4.40613 71.0236 4.40677 71.0203C4.4075 71.0166 4.40959 71.0092 4.4141 71C4.41862 70.9908 4.42327 70.9846 4.42576 70.9818C4.42793 70.9793 4.42602 70.9821 4.41815 70.9872C4.41423 70.9898 4.40944 70.9925 4.40398 70.9951C4.39844 70.9976 4.39339 70.9995 4.38943 71.0007C4.3854 71.0019 4.38427 71.0019 4.38695 71.0015C4.3896 71.0011 4.39832 71 4.4141 71V63C-2.22461 63 -5.97471 70.6194 -1.92514 75.8799L4.41411 71ZM23.9998 96.4426L4.4141 71L-1.92514 75.88L17.6606 101.323L23.9998 96.4426ZM23.9998 96.4426V96.4426L17.6605 101.323C20.863 105.483 27.1366 105.483 30.339 101.323L23.9998 96.4426ZM43.5855 71L23.9998 96.4426L30.339 101.323L49.9247 75.88L43.5855 71ZM43.5855 71C43.6013 71 43.61 71.0011 43.6127 71.0015C43.6153 71.0019 43.6142 71.0019 43.6102 71.0007C43.6062 70.9995 43.6012 70.9976 43.5956 70.9951C43.5902 70.9925 43.5854 70.9898 43.5814 70.9873C43.5736 70.9821 43.5717 70.9793 43.5738 70.9818C43.5763 70.9846 43.581 70.9908 43.5855 71C43.59 71.0092 43.5921 71.0166 43.5928 71.0204C43.5935 71.0236 43.5924 71.0203 43.5931 71.011C43.5935 71.0063 43.5943 71.0009 43.5956 70.995C43.5969 70.989 43.5985 70.9839 43.6 70.98C43.6015 70.9761 43.6022 70.9752 43.6009 70.9776C43.5996 70.9799 43.5951 70.9875 43.5855 71L49.9247 75.88C53.9743 70.6194 50.2242 63 43.5855 63V71ZM35.9988 71H43.5855V63H35.9988V71ZM31.9988 0V67H39.9988V0H31.9988Z",
  fill: "#212121",
  mask: "url(#path-1-inside-1_463_2734)"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "grid grid-cols-4 mt-12 flex-wrap justify-evenly w-full mt-10" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "p-4 text-center text-2xl mb-10" }
const _hoisted_16 = { class: "text-left pl-20 w-full mb-32 mt-10 justify-between flex pr-20" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "92",
  height: "62",
  viewBox: "0 0 46 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-4 mt-1.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M44.5 15.5H1.5",
    stroke: "#212121",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.5 1.5L1.5 15.5L15.5 29.5",
    stroke: "#212121",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "92",
  height: "62",
  viewBox: "0 0 46 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "ml-4 mt-1.5 stroke-current"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 15.5L44.5 15.5",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M30.5 29.5L44.5 15.5L30.5 1.5",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.t('intro.screen-2.title-1')), 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.t('intro.screen-2.title-2')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_ctx.description === false)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.t('intro.screen-2.sub-title-1')), 1),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.t('intro.screen-2.sub-title-2')), 1)
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.description), 1)),
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass([_ctx.description !== false ? 'hidden' : '', "mt-10"]),
          width: "96",
          height: "202",
          viewBox: "0 0 48 101",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_12, 2)),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stories, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["flex flex-col items-center", [_ctx.selectedIndex === index ? 'opacity-100' : 'opacity-80']]),
              onClick: ($event: any) => (_ctx.selectStory(item, index))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
              `bg-stories-${_ctx.colors[index]} 
              circle text-white flex justify-center items-center font-bold text-5xl`,

              _ctx.selectedIndex === index
                ? `border-text-white shadow-${_ctx.colors[index]}`
                : `border-stories-${_ctx.colors[index]}`,
            ])
              }, _toDisplayString(index + 1), 3),
              _createElementVNode("p", _hoisted_15, _toDisplayString(item && item.title[0] ? item.title[0].value : ''), 1)
            ], 10, _hoisted_14))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "flex text-4xl font-light bg-text-white text-text-black py-7 px-10 rounded-2xl shadow-1xl",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args)))
          }, [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(_ctx.t('intro.screen-2.button-back')), 1)
          ]),
          _withDirectives(_createElementVNode("button", {
            class: _normalizeClass([
            `
            flex
            text-4xl
            font-light
            text-text-white
            py-7
            px-10
            rounded-2xl
            shadow-1xl
            
          `,
            _ctx.selectedIndex !== undefined
              ? `bg-stories-${_ctx.colors[_ctx.selectedIndex]}`
              : `bg-text-black`,
          ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextStep(_ctx.stories[_ctx.selectedIndex], _ctx.selectedIndex)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.t('intro.screen-2.button-next')) + " ", 1),
            _hoisted_18
          ], 2), [
            [_vShow, _ctx.selectedIndex !== undefined]
          ])
        ])
      ])
    ])
  ], 64))
}